// @flow
import ttiPolyfill from 'tti-polyfill';
// When we are not within a document context (i.e. on the SERVER or a service worker) stub this with a no-op promise that never resolves/rejects for the sake of not throwing SSR errors
const promise =
  // eslint-disable-next-line ta-code-conventions/lithium-string-blacklist,no-restricted-globals
  SERVER || typeof window === 'undefined'
    ? new Promise(() => {})
    : ttiPolyfill.getFirstConsistentlyInteractive({});
let callbackId = 0;
const callbackSet = new Set();
// If the promise has already resolved, then this callback will instantly resolve as well.
// Otherwise, the promise will resolve when the user is interactive
const requestTTICallback = (callback: (tti: ?number) => mixed) => {
  // And make sure no one tries this on the server cause uhh it won't work
  // eslint-disable-next-line ta-code-conventions/lithium-string-blacklist
  if (SERVER) {
    throw new Error('This callback should not execute on the server!');
  }
  const id = callbackId;
  callbackSet.add(id);
  callbackId++;
  // Do a little promise magic on a singleton module promise to achieve 2 use cases:
  // 1. Subscription-based logic so we only need to calculate first consistent interactive once, then push to ALL clients (instead of each client computing it individually)
  // 2. If first consistent interactive has already fired, then this promise instantly resolves (So we can guaranteed this will eventually fire)
  promise.then(tti => {
    // We can't actually cancel es6 promises, but we can make the thenable a no-op when it should be cancelled
    if (callbackSet.has(id)) {
      callback(tti);
    }
  });
  return id;
};

const cancelTTICallback = (id: number) => {
  callbackSet.delete(id);
};

export { requestTTICallback, cancelTTICallback };
